import { render, staticRenderFns } from "./online-study.vue?vue&type=template&id=baf87b40&scoped=true&"
import script from "./online-study.vue?vue&type=script&lang=ts&"
export * from "./online-study.vue?vue&type=script&lang=ts&"
import style0 from "./online-study.vue?vue&type=style&index=0&id=baf87b40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf87b40",
  null
  
)

export default component.exports